const Images = {
  tcg_logo: require("./imgs/tcg-logo-full-color-rgb_resized.png"),
  placeholder_Image: require("./imgs/Placeholder_Image.png"),
};

const Icons = {
  search: require("./svg/search.svg").default,
  chevron_down: require("./svg/chevron_down.svg").default,
  checkbox_blank: require("./svg/checkbox_blank.svg").default,
  checkbox_checked: require("./svg/checkbox_checked.svg").default,
};
export { Images, Icons };
